import axios, { AxiosError } from 'axios';
import { Agent } from 'https';
import { URLs } from '../constants/urls';
import { CRS_KEY, isDevMode } from '../constants/variables';

const axiosTimeout = 180_000;
const _agentOptions = { keepAlive: true };

const DefaultAxiosConfig = {
    baseURL: URLs.api,
    timeout: axiosTimeout,
    httpsAgent: new Agent(_agentOptions),
    httpAgent: new Agent(_agentOptions),
    transitional: {
        forcedJSONParsing: true,
    },
};

export const instance = axios.create({
    ...DefaultAxiosConfig,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

export const instanceTS = axios.create({
    ...DefaultAxiosConfig,
    baseURL: URLs.apiTS,
});

export const imageInstance = axios.create({
    ...DefaultAxiosConfig,
    baseURL: URLs.image,
});

export const apiImageInstance = axios.create({
    ...DefaultAxiosConfig,
    baseURL: URLs.apiImage,
});

export const megacacheTS = axios.create({
    ...DefaultAxiosConfig,
    baseURL: URLs.megacache,
});

export const crsInstance = axios.create({
    ...DefaultAxiosConfig,
    baseURL: URLs.crs,
    headers: {
        'X-Api-Key': CRS_KEY,
    },
});

const errorHandler = (error: AxiosError): Promise<AxiosError> => {
    if (
        error.request instanceof Object &&
        error.request.method &&
        error.request.path &&
        !error.request.path.includes('/public/faq')
    ) {
        //         console.log(`Failed ${error?.request?.method} ${error?.request?.path}`);
        /* captureException(error, {
            extra: {
                requestData: {
                    url: error.response?.config.url,
                    method: error.response?.config.method,
                    headers: error.response?.config.headers,
                    instance: error.response?.config.baseURL,
                    request_data: error.response?.config.data,
                },
                responseData: {
                    data: error.response?.data,
                    status: error.response?.status,
                },
            },
        }); */
    }

    return Promise.reject(error);
};

if (isDevMode) {
    instance.interceptors.request.use((request) => {
        console.info('[Axios Request]', request.url, request.params);
        console.info(
            '[Axios Request]',
            `${request.baseURL}${request.url}?${
                request.params
                    ? Object.entries(request.params)
                          .map(([key, value]) => `${key}=${value}`)
                          .join('&')
                    : ''
            }`
        );
        return request;
    });

    imageInstance.interceptors.request.use((request) => {
        console.info('[Axios Image Request]', request.url, request.params);
        console.info(
            '[Axios Image Request]',
            `${request.baseURL}${request.url}?${
                request.params
                    ? Object.entries(request.params)
                          .map(([key, value]) => `${key}=${value}`)
                          .join('&')
                    : ''
            }`
        );
        return request;
    });

    apiImageInstance.interceptors.request.use((request) => {
        console.info('[Axios API Image Request]', request.url, request.params);
        console.info(
            '[Axios API Image Request]',
            `${request.baseURL}${request.url}?${
                request.params
                    ? Object.entries(request.params)
                          .map(([key, value]) => `${key}=${value}`)
                          .join('&')
                    : ''
            }`
        );
        return request;
    });

    megacacheTS.interceptors.request.use((request) => {
        console.info('[Axios Megacache TS Request]', request.url, request.params);
        console.info(
            '[Axios Megacache TS Request]',
            `${request.baseURL}${request.url}?${
                request.params
                    ? Object.entries(request.params)
                          .map(([key, value]) => `${key}=${value}`)
                          .join('&')
                    : ''
            }`
        );
        return request;
    });
}

instance.interceptors.response.use(
    (response) => response,
    (error) => errorHandler(error)
);
imageInstance.interceptors.response.use(
    (response) => response,
    (error) => errorHandler(error)
);
apiImageInstance.interceptors.response.use(
    (response) => response,
    (error) => errorHandler(error)
);

export default instance;
